module.exports = __webpack_public_path__ + "static/media/google.28a7b4b1.svg";